import React from 'react';
import {Flex} from "antd";
import classes from './header.module.css';
import Logo from "../Logo/Logo";
import MyText from "../../../components/UI/Text/MyText";
import BlueButton from "../../../components/UI/Buttons/BlueButton";
import DefaultButton from "../../../components/UI/Buttons/DefaultButton";
import IntlMessage from "../../../components/IntlMessage/IntlMessage";

const Header = () => {
    return (
        <>
            <div style={{height: 75}}></div>
            <Flex style={{width: "100%", height: 75, padding: 15}} className={classes.header} vertical align={"center"} justify={"center"}>
                <Flex style={{width: "100%", maxWidth: 1440}} className={classes.headerInner} align={"center"} justify={"space-between"}>
                    <Logo/>
                    <Flex gap={40} align={"center"} justify={"center"}>
                        <Flex gap={40} align={"center"} justify={"center"}>
                            <MyText hoverable style={{cursor: "pointer", fontSize: "0.9rem"}}>
                                <IntlMessage id={'home'}/>
                            </MyText>
                            <MyText hoverable style={{cursor: "pointer", fontSize: "0.9rem"}}>
                                <IntlMessage id={'aboutUs'}/>
                            </MyText>
                            <MyText hoverable style={{cursor: "pointer", fontSize: "0.9rem"}}>
                                <IntlMessage id={'homePage.monitoring'}/>
                            </MyText>
                        </Flex>
                        <Flex gap={15} align={"center"} justify={"center"}>
                            <BlueButton>
                                <IntlMessage id={'login'}/>
                            </BlueButton>
                            <DefaultButton>
                                <IntlMessage id={'registration'}/>
                            </DefaultButton>
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>
        </>
    );
};

export default Header;